import React from "react";

// MiniBarChart
export default function MiniBarChart({ value, avg, max }) {
    const W = 48;
    const H = 48;
    const PAD_V = 4;
    const BAR_W = 22;
    const BAR_X = (W - BAR_W) / 2;
    const chartH = H - PAD_V * 2;

    const safeValue = (typeof value === "number" && isFinite(value)) ? value : 0;
    const safeAvg   = (typeof avg   === "number" && isFinite(avg))   ? avg   : 0;
    const safeMax   = (typeof max   === "number" && max > 0)         ? max   : 1;

    const barH  = Math.max((safeValue / safeMax) * chartH, 0);
    const barY  = PAD_V + chartH - barH;
    const avgY  = PAD_V + chartH - (safeAvg / safeMax) * chartH;

    return (
        <svg
            width={W}
            height={H}
            style={{ display: "block", borderRadius: "4px", overflow: "visible" }}
            aria-label={`value ${safeValue}, avg ${Math.round(safeAvg * 100) / 100}`}
        >
            <rect x="0" y="0" width={W} height={H} fill="#f1f5f9" rx="3" />

            <rect
                x={BAR_X}
                y={barY}
                width={BAR_W}
                height={Math.max(barH, 1)}
                fill="#3b82f6"
                rx="2"
                opacity="0.85"
            />

            <line
                x1="3"  y1={avgY}
                x2={W - 3} y2={avgY}
                stroke="#ef4444"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
}
